import React from 'react';
import _ from 'lodash';
import dayjs from 'dayjs';
import emrTypeHelper from '@/helper/emrType';
import constants from '@/constants';
import SurvivalIndexItem from './SurvivalIndexItem';

interface Props {
  serviceInfo?: IMServiceInfo;
  healthsIndex?: any;
  emrTypes?: Record<string, IEMRType>;
  navigate: (path: string, options?: Record<string, any>) => void;
  user?: Record<string, any>;
}

const SurvivalIndex = ({ serviceInfo, healthsIndex, emrTypes, navigate, user }: Props) => {
  const renderItem = (config: any | Index, key: number) => {
    const data: any = {};
    const componentData = healthsIndex[config.emrTypeGetData];
    const emrConfig = emrTypes?.[config.emrTypeOpen];

    Object.keys(config.routeValue || {})?.forEach((k) => {
      const route: string = config.routeValue?.[k]?.value || config.routeValue?.[k];
      const routeConfig = config.routeValue?.[k]?.config;

      data[k] = _.get(componentData, route);
      if (routeConfig) {
        const [emrTypeCode, fieldKey] = routeConfig.split('.');
        const emrType = emrTypes?.[emrTypeCode] as IEMRType;
        const fieldConfig: IFieldConfig = emrTypeHelper.getFieldConfig(emrType, fieldKey as string) as IFieldConfig;
        const valueOption = emrTypeHelper.getOption(fieldConfig, data[k]);

        if (valueOption) {
          data[k] = `<b style="color: ${valueOption.color}">
            ${valueOption.label}
          </b>`;
        } else if (fieldConfig?.inputType === 'date') {
          data[k] = data[k] ? dayjs(data[k]).format(fieldConfig.extra.format || constants.DATE_FORMAT) : data[k];
        }
      }
    });

    const show = config?.format?.replace(/\{([\w.]+)\}/g, (match: any, key: string | number) => {
      return typeof data?.[key] !== 'undefined' ? data?.[key] : '--';
    });

    const sameDay = componentData?.date && dayjs(componentData?.date).isSame(dayjs(), 'day');
    if (config.noDataIsHidden && !componentData) {
      return;
    }

    return (
      <SurvivalIndexItem
        sameDay={sameDay}
        key={key.toString()}
        user={user}
        emrConfig={emrConfig}
        data={componentData}
        navigate={navigate}
        show={show}
        config={config}
      />
    );
  };

  return (
    <>
      <div className="w-full justify-between flex flex-row pr-6 pl-6 mb-4 items-center">
        <span className="label-large">{serviceInfo?.label ?? 'Chỉ số sinh tồn'}</span>
      </div>
      {serviceInfo && healthsIndex && serviceInfo?.index.map(renderItem)}
      {/* {serviceInfo && healthsIndex && serviceInfo?.index ? renderItem(serviceInfo?.index[0], 0) : <></>} */}
    </>
  );
};

export default SurvivalIndex;
